/**
 * @file   古琴之音
 * @create macaiqi 2025/07/07
 * @update 
 */
import React, { useState } from 'react';
import cls from 'classnames'
import Slider from 'react-slick';
import './index.scss'

export default function GQZY({ setShow }) {
    const NextArrow = ({ className, style, onClick }) => (
        <div className={cls(className)} onClick={onClick} style={style} />
    );
    const PrevArrow = ({ className, style, onClick }) => (
        <div className={cls(className)} onClick={onClick} style={style} />
    );
    const [section, setSection] = useState('section1')
    const settings = {
        dots: false,
        infinite: false,
        speed: 1000,
        arrow: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
    };
    return (
        <div className='common-page gqzy-page'>
            {section === 'section1' && <div className="  section1">
                <div className="title"></div>
                <div className="txt">
                    古琴虽只有七根弦，但每根弦均包含有两个八度以上的音，属于一弦多音乐器，音域较为宽广。古琴共计有散音(空弦音)七个，泛音则以音色清晰明亮为标准，每根弦十三徽上的泛音，加上1400多年前《碣石调·幽兰》谱中已出现过的“暗徽”泛音，每根弦一徽、十三徽两侧还有四个泛音，总计共119个泛音。另有按音147个。
                </div>
                <i className="down " onClick={() => {
                    setSection('section2');
                }}></i>
                <div
                    className="back"
                    onClick={() => {
                        setShow();
                    }}
                ></div>
            </div>}
            {section === 'section2' && <div className=" section2  animate__animated animate__fadeInUp">
                <div className="title2">
                    弹奏方式
                </div>
                <div className="cont">
                    <p>古琴的弹奏方式是以右手弹拨琴弦发声，左手通过点按琴弦的方式与右手配合，从而使音高发生变化，在弹琴技巧长期的传承与发展过程中，产生了独特丰富的指法。</p>
                    <Slider {...settings}>
                        {Array(8).fill('')?.map((item, index) => {
                            return (
                                <div key={index}>
                                    <div className={cls("item", `item${index + 1}`)}>

                                    </div>
                                </div>


                            );
                        })}
                    </Slider>
                    <p>基本的右手指法包括“抹、挑、勾、剔”，这些是古琴演奏的基础。其中“抹”是指食指向内拨弦，“挑”是指食指向外拨弦，“勾”是指中指向内拨弦，“剔”是指中指向外拨弦。这些基本指法是演奏古琴时必须掌握的技巧，它们共同构成了古琴音乐的基本框架。</p>
                    <p>在这些基础之上，更高级的技巧如“吟、猱、绰、注”则赋予了古琴音乐更为丰富的表现力。“吟”是指在弹奏一个音后，左手在该音位上轻微颤动，产生一种悠扬的效果；“猱”则是在弹奏一个音后，左手在该音位上下滑动，产生一种激昂的效果；“绰”和“注”则涉及到音高的细微变化，通过左手的上下移动来实现。</p>
                </div>
                <div
                    className="back"
                    onClick={() => {
                        setSection('section1');
                    }}
                ></div>
            </div>
            }
        </div>
    )
}
